export default __webpack_public_path__ + "images/074d8559060ff5ace93a784760861676-tgr.svg";